<template>
  <svg
    class="h-8 w-auto fill-current"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path :d="path" />
  </svg>
</template>

<script>
import icons from "./icons.json";

export default {
  name: "appicon",
  props: {
    name: String
  },
  computed: {
    path() {
      return icons[this.name];
    }
  }
};
</script>
